export default {
  name: "LowAgeConfirmModal",
  data: function data() {
    return {
      visible: false,
      isAgree: false,
      content: ''
    };
  },
  methods: {
    //检查是否为低龄，是返回true并显示确认框
    check: function check(idcard) {
      //this.visible = true;
      if (idcard && idcard.length == 18 && this.isLowAge(idcard)) {
        this.visible = true;
        return true;
      }
      return false;
    },
    hide: function hide() {
      this.visible = false;
    },
    handleOk: function handleOk(isAgree) {
      this.$emit("ok", isAgree);
      this.visible = false;
    },
    //是否低龄
    isLowAge: function isLowAge(idcard) {
      console.log("idcard", idcard);
      //9岁以下的或9岁且月份小于9的
      var currentYear = new Date().getFullYear();
      var idcardYear = parseInt(idcard.slice(6, 10));
      var idcardMonth = parseInt(idcard.slice(10, 12));
      if (currentYear - idcardYear < 9) {
        return true;
      } else if (currentYear - idcardYear == 9 && idcardMonth > 8) {
        return true;
      }
      return false;
    }
  }
};